<template>
  <div>
    <v-btn icon flat @click="setItem">
      <v-icon color="teal">edit</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: () => ({}),
  methods: {
    setItem() {
      this.params.clicked(this.params.data);
    },
  },
});
</script>
